export default "__VITE_ASSET__CeWPQ4ym__"